
import {getAppIconChar} from '../cmx/CxIconChar';
import {System} from './System';
import {Project} from './Project';
import {DateUtil} from '../lib/DateUtil';
import {JsonUtil} from '../lib/JsonUtil';
import {i18n} from "../ctx/I18n";

const taskColumns = [
    { field: 'start_date',        headerName: 'Startdatum',             type: 'string',  width: 120, sortable: true },
    { field: 'end_date',          headerName: 'Enddatum',               type: 'string',  width: 120, sortable: true },
    { field: 'startDate',         headerName: 'Startdatum',             type: 'string',  width: 120, sortable: false},
    { field: 'endDate',           headerName: 'Enddatum',               type: 'string',  width: 120, sortable: false},

    { field: 'task',              headerName: 'Arbeitskategorie',       type: 'string',  width: 250, sortable: true },
    { field: 'sub_task',          headerName: 'Arbeitsvorgang',         type: 'string',  width: 250, sortable: true },

    { field: 'architect',         headerName: 'Architekt',              type: 'string',  width: 200, sortable: true },
    // { field: 'doc_count',      headerName: 'Dok',                    type: 'number',  width:  80, sortable: false},
    { field: 'project_desc',      headerName: 'Beschreibung',           type: 'string',  width: 300, sortable: false},
    { field: 'dimension',         headerName: 'Mass',                   type: 'string',  width: 200, sortable: true },
    { field: 'warranty',          headerName: 'Garantie Verursacher',   type: 'string',  width: 200, sortable: true },
    { field: 'warranty_cause',    headerName: 'Garantie Ursache',       type: 'string',  width: 150, sortable: true },

    { field: 'address',           headerName: 'Adresse',                type: 'string',  width: 100, sortable: true },
    { field: 'zip',               headerName: 'PLZ',                    type: 'string',  width: 100, sortable: true },
    { field: 'city',              headerName: 'Ort',                    type: 'string',  width: 150, sortable: true },

    { field: 'sm_name',           headerName: 'Bauleiter',              type: 'string',  width: 120, sortable: true },
    { field: 'sm_phone',          headerName: 'Bauleiter Telefon',      type: 'string',  width: 140, sortable: true },
    { field: 'sm_email',          headerName: 'Bauleiter E-Mail',       type: 'string',  width: 200, sortable: true },

    { field: 'avorStateLabel',    headerName: 'Vorausmass',             type: 'string',  width: 100, sortable: true },

    { field: 'foreman',           headerName: 'BF (Stv.)',              type: 'string',  width:  90, sortable: true },
    { field: 'number',            headerName: 'Nr.',                    type: 'string',  width:  30, sortable: true },
    { field: 'team_lead',         headerName: 'Gruppe',                 type: 'string',  width: 150, sortable: true },
    { field: 'team_member',       headerName: 'Mitglieder',             type: 'string',  width: 200, sortable: false},
    { field: 'clearedLabel',      headerName: 'Abgeräumt',              type: 'string',  width: 100, sortable: false},
    { field: 'pump',              headerName: 'Pumpe',                  type: 'string',  width: 100, sortable: false},
    { field: 'info',              headerName: 'Info',                   type: 'string',  width: 200, sortable: false},
    { field: 'project_ref',       headerName: 'Projekt Nr',             type: 'string',  width: 100, sortable: true },

    { field: 'prep1Label',          headerName: i18n.prep1,             type: 'string',  width: 100, sortable: true},
    { field: 'prep2Label',          headerName: i18n.prep2,             type: 'string',  width: 100, sortable: true},
    { field: 'prep3Label',          headerName: i18n.prep3,             type: 'string',  width: 100, sortable: true},
    { field: 'prep4Label',          headerName: i18n.prep4,             type: 'string',  width: 100, sortable: true},
    { field: 'prep5Label',          headerName: i18n.prep5,             type: 'string',  width: 100, sortable: true},
    { field: 'prep6Label',          headerName: i18n.prep6,             type: 'string',  width: 100, sortable: true},
    { field: 'prep7Label',          headerName: i18n.prep7,             type: 'string',  width: 100, sortable: true},
    { field: 'prep8Label',          headerName: i18n.prep8,             type: 'string',  width: 100, sortable: true},
    { field: 'prep9Label',          headerName: i18n.prep9,             type: 'string',  width: 100, sortable: true},
    { field: 'prep_info',           headerName: i18n.prepInfo,          type: 'string',  width: 100, sortable: true },

    { field: 'project_id',        headerName: 'Project Id',             type: 'number',  width:  70, sortable: true },
    { field: 'id',                headerName: 'Task Id',                type: 'number',  width:  70, sortable: true }
];

const taskColumnsMap = Object.fromEntries(taskColumns.map(col => [col.field, col]));

export const Task = {

    mapListColumns(tasks, code, crew, includeExtensionDetails = false) {
        return tasks.map(task => {
            const taskValue    = code.getValue(task.task_code_key);
            const taskOrder    = code.getOrder(task.task_code_key);
            const subTaskValue = code.getValue(task.sub_task_code_key);

            const foremanName  = crew.getInitials(task.foreman_crew_id);
            const deputyName   = crew.getInitials(task.deputy_foreman_crew_id);
            const foremanLabel = deputyName ? `${foremanName} (${deputyName})` : foremanName;

            const avorStateLabel = Project.getAvorStateLabel(task.avor_state);

            const teamLeadName = crew.getName(task.team_lead_crew_id);
            let teamNames      = crew.getNames(task.team_member_crew_ids);
            const warrantyName = crew.getName(task.warranty_crew_id);
            const extensions= this.mapDbToForm4Extensions(task.extensions); // important, each extension needs a unique id
            const hasExtensions = extensions.length > 0 ? true : false;
            if (hasExtensions) {
                teamNames = getAppIconChar('extensionWeek', ' ') + teamNames;
                if (includeExtensionDetails) {
                    const details = extensions.map(ext => {
                        return `${ext.date}:\n   ${crew.getNames(ext.crew_ids)}`;
                    }).join('\n');
                    teamNames = teamNames + '\n' + details;
                }
            }

            let pump = code.getValue(task.pump_code_key);
            if (pump === "Dieselpumpe") {
                pump = "Diesel";
            } else if (pump === "Elektropumpe") {
                pump = "Elektro";
            }
            const clearedLabel = task.cleared === 1 ? "Ja" : "Nein";
            const closedLabel  = task.closed  === 1 ? "Ja" : "Nein";

            const prep1Label   = Project.getPrepStateLabel(task.prep_1);
            const prep2Label   = Project.getPrepStateLabel(task.prep_2);
            const prep3Label   = Project.getPrepStateLabel(task.prep_3);
            const prep4Label   = Project.getPrepStateLabel(task.prep_4);
            const prep5Label   = Project.getPrepStateLabel(task.prep_5);
            const prep6Label   = Project.getPrepStateLabel(task.prep_6);
            const prep7Label   = Project.getPrepStateLabel(task.prep_7);
            const prep8Label   = Project.getPrepStateLabel(task.prep_8);
            const prep9Label   = Project.getPrepStateLabel(task.prep_9);

            const startDate = DateUtil.convertIsoStringToString(task.start_date)
            const endDate = DateUtil.convertIsoStringToString(task.end_date)

            return {
                ...task,
                task: taskValue,
                taskOrder: taskOrder,
                sub_task: subTaskValue,
                avorStateLabel: avorStateLabel,
                foreman: foremanLabel,
                closedLabel: closedLabel,
                warranty: warrantyName,
                team_lead: teamLeadName,
                team_member: teamNames,
                has_extensions: hasExtensions,
                extensions: extensions,
                pump: pump,
                clearedLabel: clearedLabel,
                prep1Label: prep1Label,
                prep2Label: prep2Label,
                prep3Label: prep3Label,
                prep4Label: prep4Label,
                prep5Label: prep5Label,
                prep6Label: prep6Label,
                prep7Label: prep7Label,
                prep8Label: prep8Label,
                prep9Label: prep9Label,
                startDate: startDate,
                endDate: endDate
            };
        });
    },

    mapListColumMembers4Day(task, isoDay, crew) {

        // return original members if task has no extensions (no change needed)
        if (!task.has_extensions) {
            return {
                team_member_crew_ids: task.team_member_crew_ids,
                team_member         : task.team_member
            }
        }

        // return day view with pin (if extension matches)
        const extMatch = task.extensions.find(ext => ext.date === isoDay);
        if (extMatch) {
            return {
                team_member_crew_ids: extMatch.crew_ids,
                team_member         : getAppIconChar('extensionDay', ' ') + crew.getNames(extMatch.crew_ids)
            };
        }

        // return day view with original members but without extension marker, since for this specific day,
        // no extension changes are active/made.
        return {
            team_member_crew_ids: task.team_member_crew_ids,
            team_member         : crew.getNames(task.team_member_crew_ids)
        };
    },

    getArchiveColumns() {
        const fields = ['task', 'sub_task', 'start_date', 'end_date', 'dimension',
            'number', 'team_lead', 'team_member', 'info', 'pump', 'warranty', 'warranty_cause', 'clearedLabel', 'id'];

        return fields.map(f => taskColumnsMap[f]).filter(Boolean);
    },

    getListColumns(includeTaskColumn = false, includeWarranty=false, includeSystemColumns = false) {

        const fields = ['startDate', 'endDate', 'architect', 'dimension', 'avorStateLabel', 'sub_task', 'project_desc',
            'address', 'zip', 'city', 'foreman', 'number', 'team_lead', 'team_member', 'clearedLabel', 'pump',
            'info', 'doc_count', 'project_ref'];

        if (includeTaskColumn) {
            fields.splice(0, 0, 'task');
        }

        if (includeWarranty) {
            fields.splice(0, 0, 'warranty_cause');
            fields.splice(0, 0, 'warranty');
        }

        const columns = fields.map(f => taskColumnsMap[f]).filter(Boolean);

        if (includeSystemColumns) {
            columns.push(...System.getSystemColumns());
        }

        return columns;
    },

    getListTeamColumns() {
        const fields = ['startDate', 'endDate', 'number', 'architect', 'task', 'sub_task', 'team_member',
            'project_desc', 'address', 'zip', 'city', 'foreman', 'doc_count', 'project_ref'];

        return fields.map(f => taskColumnsMap[f]).filter(Boolean);
    },

    getListSiteColumns() {
        const fields = ['project_desc','address', 'zip', 'city','architect',
            'sm_name','sm_phone','sm_email', 'foreman',
            'prep1Label', 'prep2Label', 'prep3Label', 'prep4Label', 'prep5Label', 'prep6Label', 'prep_info']

        return fields.map(f => taskColumnsMap[f]).filter(Boolean);
    },

    getReportPlanColumns() {
        return this.getListColumns(true, false, false);
    },

    getReportPlanTaskColumns() {
        return this.getListColumns(true, false, false);
    },

    getReportPlanTeamColumns() {
        const fields = ['startDate', 'endDate', 'number', 'architect', 'task', 'sub_task', 'team_lead', 'team_member',
            'project_desc', 'address', 'zip', 'city', 'foreman', 'project_ref'];

        return fields.map(f => taskColumnsMap[f]).filter(Boolean);
    },

    getReportMaterialColumns() {
        const fields = ['task', 'startDate', 'endDate', 'sub_task', 'architect', 'dimension', 'project_desc',
            'address', 'zip', 'city', 'foreman', 'project_ref'];

        return fields.map(f => taskColumnsMap[f]).filter(Boolean);
    },

    getReportClearingColumns() {
        const fields = ['task', 'foreman', 'endDate', 'sub_task', 'architect', 'dimension', 'project_desc',
            'address', 'zip', 'city', 'team_lead', 'clearedLabel'];

        return fields.map(f => taskColumnsMap[f]).filter(Boolean);
    },

    getReportToolColumns() {
        const fields = ['startDate', 'endDate', 'task', 'sub_task', 'project_desc',
            'address', 'zip', 'city', 'foreman', 'team_lead', 'pump', 'info', 'project_ref'];

        return fields.map(f => taskColumnsMap[f]).filter(Boolean);
    },

    getReportWarrantyColumns() {
        return this.getListColumns(false, true);
    },

    getReportSiteColumns() {
        return this.getListSiteColumns();
    },

    getProjectDetailColumns(includeSystemColumns = false) {
        const fields = ['task', 'sub_task', 'start_date', 'end_date', 'dimension',
            'number', 'team_lead', 'team_member', 'info', 'doc_count', 'warranty', 'warranty_cause', 'id'];

        const columns = fields.map(f => taskColumnsMap[f]).filter(Boolean);

        if (includeSystemColumns) {
            columns.push(...System.getSystemColumns());
        }

        return columns;
    },

    /**
     * Extract project data part from task data. The task data comes from the task and archived task search
     * and is used to display the data in the ProjectDetail and ArchiveDetail component.
     */
    extractProjectData(data) {
        return {
            id: data.project_id,
            project_ref: data.project_ref,
            project_desc: data.project_desc,
            architect: data.architect,
            initial_date: data.initial_date,
            address: data.address,
            zip: data.zip,
            city: data.city,
            sm_name: data.sm_name,
            sm_phone: data.sm_phone,
            sm_email: data.sm_email,
            foreman_crew_id: data.foreman_crew_id,
            deputy_foreman_crew_id: data.deputy_foreman_crew_id,
            foreman: data.foreman,
            avor_amount: data.avor_amount,
            avor_state: data.avor_state,
            avor_created_crew_id: data.avor_created_crew_id,
            avor_created_at: data.avor_created_at,
            prep_1: data.prep_1,
            prep_2: data.prep_2,
            prep_3: data.prep_3,
            prep_4: data.prep_4,
            prep_5: data.prep_5,
            prep_6: data.prep_6,
            prep_7: data.prep_7,
            prep_8: data.prep_8,
            prep_9: data.prep_9,
            prep_info: data.prep_info,
            closed: data.closed,
            closedLabel: data.closedLabel,
            version: data.version
        };
    },

    getFormValues(projectId, task_code_key=-1, sub_task_code_key=-1, start_date=null, end_date=null) {
        return {
            "id"                   : null,
            "project_id"           : projectId,
            "task_code_key"        : task_code_key,
            "sub_task_code_key"    : sub_task_code_key,
            "dimension"            : "",
            "start_date"           : start_date,
            "end_date"             : end_date,
            "number"               : null,
            "team_lead_source"     :  0,
            "team_lead_crew_id"    : null,
            "team_member_crew_ids" : [],
            "extensions"           : [],
            "info"                 : "",
            "pump_code_key"        : -1,
            "warranty_crew_id"     : null,
            "warranty_cause"       : "",
            "cleared"              : 0,
            "version"              : 0,
            "insert_ts"            : "",
            "insert_by"            : "",
            "update_ts"            : "",
            "update_by"            : ""
        }
    },

    getFormErrors() {
        return System.initializeFormErrors(Task.getFormValues(null));
    },

    getFormRequiredFields() {
        return [
            "task_code_key",
            "sub_task_code_key",
            "start_date",
            "end_date"
        ];
    },

    /**
     * Create extension fields with temporary id for react, date, crew_ids and the error fields date_error and
     * crew_ids_error.
     *
     * When the createExtension methode is called from the UI, a new extension will be created with the current Date
     * a fixed index and a random part. Since there is some user interaction between the creation of the extensions,
     * the date will already be unique and the fixed index 0 and the random number are just to keep the same format
     * as when loading the extensions from the database (details see mapDbToForm4Extensions).
     */
    createExtension(date, leadId, crewIds = []) {
        // convert crewIds to array
        const actualCrewIds = JsonUtil.convertJsonToObject(crewIds, []);

        // add lead_id (if avaliable) at the begin of the crewIds
        const updatedCrewIds = leadId
            ? [leadId, ...actualCrewIds]
            : [...crewIds];

        // return new extension entry
        return {
            id: `${Date.now()}-0-${Math.floor(Math.random() * 1000)}`,  // temporary id for react keys
            date: date,                                                    // date value
            crew_ids: updatedCrewIds,                                      // crewIds values
            date_error: null,                                              // date error message
            crew_ids_error: null                                           // crew ids error message
        };
    },

    /**
     * Map the extensions from the database to the form structure.
     *
     * Since we are looping very fast, the date function could return the same value, so we just call it once (also to
     * safe performance). With the index, the unique keys together with the randum number are still granted.
     */
    mapDbToForm4Extensions(extensions) {
        if (!extensions) {              // check for null, undefined and "" (empty string)
            return [];
        }

        if (Array.isArray(extensions)) {
            return extensions;
        }

        const values = JsonUtil.convertJsonStringToArray(extensions);

        const batchTimestamp = Date.now();
        const mapped = values.map((ext, index) => ({
            ...ext,
            id            : `${batchTimestamp}-${index}-${Math.floor(Math.random() * 1000)}`,
            date_error    : null,
            crew_ids_error: null
        }));

        return mapped;
    },

    /**
     * Map the DB values to form-friendly values.
     */
    mapDbToForm(dbValues) {
        const values = { ...dbValues };

        if (values.task_code_key === null) {
            values.task_code_key = -1;
        }

        if (values.sub_task_code_key === null) {
            values.sub_task_code_key = -1;
        }

        if (values.team_lead_source === null) {
            values.team_lead_source = 0;
        }

        if (values.team_member_crew_ids === null) {
            values.team_member_crew_ids = [];
        }

        if (values.pump_code_key === null) {
            values.pump_code_key = -1;
        }

        values.extensions = Task.mapDbToForm4Extensions(values.extensions);

        return values;
    },

    mapFormToDb4TeamMemberCrewIds(value) {
        if (typeof value === "string" && value.trim() !== "") {
            // If the field is a non-empty string, return it as is
            return value.trim();
        }

        if (Array.isArray(value) && value.length > 0) {
            // If the field is a non-empty array, return it as a JSON string
            return JSON.stringify(value);
        }

        // In all other cases, return null
        return null;
    },

    mapFormToDb4Extensions(extensions) {

        if (!Array.isArray(extensions)) {
            return null;
        }

        if (extensions.length === 0) {
            return null;
        }

        const mappedExtensions = extensions.map(ext => ({
            date: ext.date,
            crew_ids: ext.crew_ids
        }));

        return JSON.stringify(mappedExtensions);
    },

    mapFormToDb(formValues) {
        return {
            id                  : formValues.id,
            project_id          : formValues.project_id,
            task_code_key       : System.mapCodeToDb(formValues.task_code_key),
            sub_task_code_key   : System.mapCodeToDb(formValues.sub_task_code_key),
            dimension           : System.mapValueToDb(formValues.dimension),
            start_date          : System.mapValueToDb(formValues.start_date),
            end_date            : System.mapValueToDb(formValues.end_date),
            number              : System.mapValueToDb(formValues.number),
            team_lead_source    : System.mapValueToDb(formValues.team_lead_source),
            team_lead_crew_id   : System.mapValueToDb(formValues.team_lead_crew_id),
            team_member_crew_ids: Task.mapFormToDb4TeamMemberCrewIds(formValues.team_member_crew_ids),
            extensions          : Task.mapFormToDb4Extensions(formValues.extensions),
            info                : System.mapValueToDb(formValues.info),
            pump_code_key       : System.mapCodeToDb(formValues.pump_code_key),
            warranty_crew_id    : System.mapValueToDb(formValues.warranty_crew_id),
            warranty_cause      : System.mapValueToDb(formValues.warranty_cause),
            cleared             : formValues.cleared,
            version             : formValues.version
        }
    },

    getSearchClearedItems() {
        return [
            {label: "Alle", value :-1},
            {label: "Ja",   value :1},
            {label: "Nein", value :0}
        ]
    },

    getSearchValues() {
        return {
            "task_code_key"     : -1,
            "sub_task_code_key" : -1,
            "start_date"        : null,
            "end_date"          : null,
            "team_lead_source"  : -1,
            "team_lead_crew_id" : -1,
            "dimension"         : "",
            "info"              : "",
            "cleared"           : -1,           // Combox mit: -1=Alle, 0=nicht abgeräumt, 1=abgeräumt
            "warranty_crew_id"  : -1,           // Garantie Verursacher
            "warranty_cause"    : ""            // Garantie Ursache
        }
    },

    getSearchErrors() {
        return System.initializeFormErrors(Task.getSearchValues());
    },

    getSearchMinimalLength() {
        return {
            "dimension"         : 4,
            "info"              : 4,
            "warranty_cause"    : 4
        }
    },

    mapSearchToQuery(searchValues) {
        return {
            "task_code_key"     : System.mapCodeToQuery(searchValues.task_code_key),
            "sub_task_code_key" : System.mapCodeToQuery(searchValues.sub_task_code_key),
            "start_date"        : System.mapValueToQuery(searchValues.start_date),
            "end_date"          : System.mapValueToQuery(searchValues.end_date),
            "team_lead_source"  : System.mapCodeToQuery(searchValues.team_lead_source),
            "team_lead_crew_id" : System.mapCodeToQuery(searchValues.team_lead_crew_id),
            "dimension"         : System.mapValueToQuery(searchValues.dimension),
            "info"              : System.mapValueToQuery(searchValues.info),
            "cleared"           : System.mapCodeToQuery(searchValues.cleared),
            "warranty_crew_id"  : System.mapCodeToQuery(searchValues.warranty_crew_id),
            "warranty_cause"    : System.mapValueToQuery(searchValues.warranty_cause)
        }
    }

};

